import { faEye } from "@fortawesome/pro-duotone-svg-icons";
import { Icon } from "@progress/kendo-react-common";
import {
  InputClearValue,
  InputPrefix,
  InputSeparator,
  TextBox,
} from "@progress/kendo-react-inputs";
import { isGalleryEditor, isTableEditor } from "../../Template/NewTemplateSignals";
import { visibilityBuilderVisibility } from "../Store/CommonSignals";
import { ColorChangingIcon } from "../UI/ColorChangingIcon";

const Prefix = (_isGalleryEditor, _isTableEditor) => {
  return (
    <>
      <InputPrefix>
        <ColorChangingIcon
          icon={faEye}
          initialPrimaryColor="#605e5c"
          initialSecondaryColor="#0078D4"
          margin="1px 5px 0 5px"
          onClick={(e) => {
            e.stopPropagation();
            visibilityBuilderVisibility.value = true;
            isGalleryEditor.value = _isGalleryEditor;
            isTableEditor.value = _isTableEditor;
          }}
        />
      </InputPrefix>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
    </>
  );
};

const Suffix = ({ handlePropertyChange }) => {
  return (
    <>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
      <InputClearValue
        onClick={() => handlePropertyChange({ propName: "VisibilityRules", propValue: [] })}
      >
        <Icon name="x" />
      </InputClearValue>
    </>
  );
};

export const VisibilityRulesInput = ({
  handlePropertyChange,
  currentPropertyValues,
  isGalleryEditor,
  isTableEditor,
  disabled,
}) => {
  const ruleCount = currentPropertyValues?.VisibilityRules?.length || 0;

  let textString;
  if (ruleCount === 1) {
    textString = "1 Visibility Rule";
  } else if (ruleCount > 1) {
    textString = `${ruleCount} Visibility Rules`;
  } else {
    textString = "";
  }

  return (
    <TextBox
      name={"Expression"}
      label={"Expression"}
      disabled={disabled}
      placeholder="No visibility rules"
      readOnly={true}
      value={textString}
      prefix={() => Prefix(isGalleryEditor, isTableEditor)}
      suffix={() =>
        Suffix({
          handlePropertyChange,
        })
      }
    />
  );
};

export default VisibilityRulesInput;
